import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import MobileDashBoard from './MobileDashboard'
import DashboardPage from "./NewDashboard2023";


const DashboardWrapper:React.FC = () => {
    const isMobile = useMobileContext()
    return isMobile ? <MobileDashBoard /> : <DashboardPage />
}
export default DashboardWrapper